// ServiceDetails.tsx
import React from 'react';   // ← required for JSX when automatic runtime is not enabled

export default function ServiceDetails() {
  // Mark the array as readonly to avoid accidental changes at runtime
  const services: readonly {
    title: string;
    description: string;
  }[] = [
    {
      title: 'エアコン内部洗浄',
      description:
        '通常タイプのエアコン洗浄8,800円/1台\nロボット掃除タイプのエアコン洗浄19,800円/1台',
    },
    {
      title: 'キッチン・換気扇清掃',
      description: '換気扇、キッチンシンク、戸棚セット22,000円/1セット',
    },
    {
      title: '浴室清掃',
      description: '浴室内清掃13,200円',
    },
    {
      title: '退去時空室清掃',
      description:
        '【賃貸管理会社様・不動産オーナー様向け】\n1R・1K 13,000円（税別）〜\n1DK 17,000円（税別）\n1LDK 20,000円（税別）\n2LDK 25,000円（税別）\n3LDK 28,000円（税別）\n戸建て 70,000円（税別）',
    },
    {
      title: '高所ガラス清掃',
      description: '高所ビルやオフィスなどご相談ください。',
    },
    {
      title: '業務用エアコン洗浄',
      description: 'オフィスや店舗など何方向でも対応可能です。',
    },
  ];

  // Defensive guard – in case `services` becomes undefined in the future
  if (!services || services.length === 0) {
    return null;
  }

  return (
    <section className="py-12 sm:py-20 bg-[#F5F3EF]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        {services.map((service, index) => (
          <div key={index} className="mb-8 sm:mb-12 last:mb-0">
            <h3 className="text-lg sm:text-2xl font-bold mb-2 sm:mb-3 text-gray-800">
              {service.title}
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed whitespace-pre-line">
              {service.description}
            </p>
          </div>
        ))}

        {/* 対応エリア */}
        <div className="mt-12 sm:mt-16">
          <h3 className="text-lg sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800 flex items-center gap-2">
            <span className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-[#D4A04A]">
              <i className="ri-map-pin-line text-lg sm:text-xl"></i>
            </span>
            対応エリア
          </h3>

          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <div className="w-full h-[280px] sm:h-[400px]">
              <iframe
                title="対応エリアマップ"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d420000!2d135.4!3d34.75!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="p-4 sm:p-6">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
                <div className="flex items-start gap-2 bg-[#FBF9F5] rounded-md p-3 sm:p-4">
                  <span className="w-5 h-5 flex items-center justify-center text-[#D4A04A] mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                  </span>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-gray-800">大阪府全域</p>
                    <p className="text-xs text-gray-500 mt-0.5">大阪市内・堺市・東大阪市 他</p>
                  </div>
                </div>

                <div className="flex items-start gap-2 bg-[#FBF9F5] rounded-md p-3 sm:p-4">
                  <span className="w-5 h-5 flex items-center justify-center text-[#D4A04A] mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                  </span>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-gray-800">神戸市</p>
                    <p className="text-xs text-gray-500 mt-0.5">神戸市内全域対応</p>
                  </div>
                </div>

                <div className="flex items-start gap-2 bg-[#FBF9F5] rounded-md p-3 sm:p-4">
                  <span className="w-5 h-5 flex items-center justify-center text-[#D4A04A] mt-0.5 shrink-0">
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                  </span>
                  <div>
                    <p className="text-sm sm:text-base font-semibold text-gray-800">京都市内</p>
                    <p className="text-xs text-gray-500 mt-0.5">京都市内全域対応</p>
                  </div>
                </div>
              </div>

              <p className="text-xs text-gray-400 mt-3 sm:mt-4">
                ※上記エリア以外もご相談ください。出張費が別途かかる場合がございます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
